import { CurrencyCode } from '../constants'
import { AccountState, CurrencyRole } from '../state/AccountState'
import { createAsyncState } from '../redux/ReduxUtils'

const initialState: AccountState = createAsyncState({
	balances: [],
	bonuses: [],
	refreshable: false,
	lastUpdateTimeStamp: Date.now(),
	balanceHidden: false,
})

const localInitialState: AccountState = {
	...initialState,
	balances: [
		{
			amount: 10000,
			currencyCode: CurrencyCode.SWEEPS,
			formattedBalance: '10000.00',
			role: CurrencyRole.main,
		},
		{
			amount: 10000,
			currencyCode: CurrencyCode.GOLD_COINS,
			formattedBalance: '10000.00',
			role: CurrencyRole.main,
		},
	],
}

const LOCAL_DEV_HOSTS = ['localhost', '0.0.0.0', 'gp-docker-game-client.local']

export const initialAccountState = LOCAL_DEV_HOSTS.includes(window.location.hostname) 
  ? localInitialState 
  : initialState
